const currentYear = new Date().getFullYear();
export const YEARS_OPTIONS = Array.from({ length: currentYear - 1979 }, (_, i) => ({
    label: `${1980 + i}`,
    value: `${1980 + i}`
})).reverse()

export const MONTHS_OPTIONS = [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
];

export const ALL_JOBS = [
    { category: "softwareDevelopment", title: "Frontend Developer" },
    { category: "softwareDevelopment", title: "Backend Developer" },
    { category: "softwareDevelopment", title: "Fullstack Developer" },
    { category: "softwareDevelopment", title: "Mobile App Developer (iOS/Android)" },
    { category: "softwareDevelopment", title: "Game Developer" },
    { category: "softwareDevelopment", title: "Embedded Systems Engineer" },
    { category: "softwareDevelopment", title: "Blockchain Developer" },
    { category: "softwareDevelopment", title: "AR/VR Developer" },
    { category: "softwareDevelopment", title: "DevOps Engineer" },
    { category: "softwareDevelopment", title: "Software Engineer (Generalist)" },
    { category: "dataAndAnalytics", title: "Data Analyst" },
    { category: "dataAndAnalytics", title: "Data Scientist" },
    { category: "dataAndAnalytics", title: "Data Engineer" },
    { category: "dataAndAnalytics", title: "Business Intelligence Analyst" },
    { category: "dataAndAnalytics", title: "Machine Learning Engineer" },
    { category: "dataAndAnalytics", title: "AI Specialist" },
    { category: "dataAndAnalytics", title: "Big Data Engineer" },
    { category: "cloudComputingAndInfrastructure", title: "Cloud Engineer" },
    { category: "cloudComputingAndInfrastructure", title: "Cloud Solutions Architect" },
    { category: "cloudComputingAndInfrastructure", title: "Site Reliability Engineer (SRE)" },
    { category: "cloudComputingAndInfrastructure", title: "Systems Administrator" },
    { category: "cloudComputingAndInfrastructure", title: "Network Engineer" },
    { category: "cloudComputingAndInfrastructure", title: "Infrastructure Engineer" },
    { category: "cybersecurity", title: "Cybersecurity Analyst" },
    { category: "cybersecurity", title: "Information Security Specialist" },
    { category: "cybersecurity", title: "Penetration Tester" },
    { category: "cybersecurity", title: "Security Engineer" },
    { category: "cybersecurity", title: "Ethical Hacker" },
    { category: "cybersecurity", title: "SOC Analyst (Security Operations Center)" },
    { category: "cybersecurity", title: "IAM Specialist (Identity & Access Management)" },
    { category: "productAndProjectManagement", title: "Technical Product Manager" },
    { category: "productAndProjectManagement", title: "Product Owner" },
    { category: "productAndProjectManagement", title: "Scrum Master" },
    { category: "productAndProjectManagement", title: "Agile Coach" },
    { category: "productAndProjectManagement", title: "IT Project Manager" },
    { category: "uiUxDesign", title: "UI Designer" },
    { category: "uiUxDesign", title: "UX Designer" },
    { category: "uiUxDesign", title: "Product Designer" },
    { category: "uiUxDesign", title: "UX Researcher" },
    { category: "uiUxDesign", title: "Interaction Designer" },
    { category: "uiUxDesign", title: "Motion Graphics Designer" },
    { category: "hardwareAndElectronics", title: "Hardware Engineer" },
    { category: "hardwareAndElectronics", title: "FPGA Engineer" },
    { category: "hardwareAndElectronics", title: "IoT Specialist" },
    { category: "hardwareAndElectronics", title: "Robotics Engineer" },
    { category: "hardwareAndElectronics", title: "Electronics Design Engineer" },
    { category: "qualityAssurance", title: "QA Engineer" },
    { category: "qualityAssurance", title: "Test Automation Engineer" },
    { category: "qualityAssurance", title: "Manual Tester" },
    { category: "qualityAssurance", title: "Performance Tester" },
    { category: "qualityAssurance", title: "Usability Tester" },
    { category: "techSupportAndItOperations", title: "IT Support Specialist" },
    { category: "techSupportAndItOperations", title: "Desktop Support Technician" },
    { category: "techSupportAndItOperations", title: "Helpdesk Analyst" },
    { category: "techSupportAndItOperations", title: "Technical Support Engineer" },
    { category: "salesAndMarketing", title: "Technical Account Manager" },
    { category: "salesAndMarketing", title: "Solutions Engineer" },
    { category: "salesAndMarketing", title: "Sales Engineer" },
    { category: "salesAndMarketing", title: "Customer Success Manager (Tech)" },
    { category: "salesAndMarketing", title: "Digital Marketing Specialist (Tech Products)" },
    { category: "emergingTechnologies", title: "AI Prompt Engineer" },
    { category: "emergingTechnologies", title: "Quantum Computing Specialist" },
    { category: "emergingTechnologies", title: "Metaverse Strategist" },
    { category: "emergingTechnologies", title: "Autonomous Systems Engineer" },
    { category: "educationAndTraining", title: "Coding Instructor" },
    { category: "educationAndTraining", title: "Tech Curriculum Developer" },
    { category: "educationAndTraining", title: "IT Trainer" },
    { category: "others", title: "Technical Writer" },
    { category: "others", title: "Systems Analyst" },
    { category: "others", title: "Research Scientist (Tech)" },
    { category: "others", title: "Technical Consultant" }
  ];

  export const ALL_JOBS_OPTIONS = ALL_JOBS.map(item => ({label: item.title, value: item.title}))